import { IconButton } from '../icon-button/IconButton';
import { withPersonalizedIconButtonStyle } from '../icon-button/withPersonalizedIconButtonStyle';
import { styles } from './IconGhostBlackButton.styles';

export const IconGhostBlackButton = withPersonalizedIconButtonStyle(IconButton, styles);
